import {
  getBusinessModel,
  getCaseStudiesPath,
  getServicePackagesPath,
} from "@/config/businessModel";

export class ContentService {
  private cache = new Map<string, { data: unknown; timestamp: number }>();
  private ttl: number;

  constructor(ttl = 5 * 60 * 1000) {
    this.ttl = ttl;
  }

  async fetch<T>(slug: string): Promise<T> {
    const cached = this.cache.get(slug);
    if (cached && Date.now() - cached.timestamp < this.ttl) {
      return cached.data as T;
    }

    const cdnUrl = import.meta.env.VITE_CDN_URL;
    const response = await fetch(`${cdnUrl}/content/${slug}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch content: ${slug}`);
    }

    const data = await response.json();
    this.cache.set(slug, { data, timestamp: Date.now() });
    return data as T;
  }

  async fetchCaseStudies<T>(model = getBusinessModel()): Promise<T> {
    return this.fetch<T>(getCaseStudiesPath(model));
  }

  async fetchServicePackages<T>(model = getBusinessModel()): Promise<T> {
    return this.fetch<T>(getServicePackagesPath(model));
  }
}

export const contentService = new ContentService();
